import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useState } from 'react';

const PackageFAQ = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Paketler arasındaki temel fark nedir?',
      answer:
        'Her paket farklı büyüme aşamasındaki acenteler için tasarlanmıştır. Dijital Varlık Paketi yeni başlayanlar için temel dijital varlık oluşturur, Satış Odaklı Paket sürekli lead akışı sağlar, Bölge Liderliği Paketi ise pazarda lider olmak isteyen acenteler için kapsamlı çözümler sunar.',
    },
    {
      question: 'Paketleri özelleştirebilir miyim?',
      answer:
        'Evet, tüm paketler tamamen özelleştirilebilir. İhtiyaçlarınıza göre hizmetleri ekleyebilir veya çıkarabilirsiniz. Ücretsiz danışmanlık görüşmesinde size özel bir paket oluşturabiliriz.',
    },
    {
      question: 'Ödeme nasıl yapılır?',
      answer:
        'Ödeme planları esnektir. Peşin ödeme veya taksitli ödeme seçenekleri sunuyoruz. Sözleşme imzalandıktan sonra %50 ön ödeme, proje tesliminde kalan %50 ödeme yapılır. Aylık hizmetler için ise aylık faturalandırma yapılır.',
    },
    {
      question: 'Proje ne kadar sürede tamamlanır?',
      answer:
        'Dijital Varlık Paketi 2-3 hafta, Satış Odaklı Paket 3-4 hafta, Bölge Liderliği Paketi 4-6 hafta içinde tamamlanır. Sözleşme sonrası 3-5 iş günü içinde projeniz başlar ve düzenli olarak ilerleme raporları alırsınız.',
    },
    {
      question: 'Reklam bütçesi dahil mi?',
      answer:
        'Hayır, paket fiyatları sadece hizmet bedelleridir. Google ve Meta reklam bütçeleri ayrıca planlanır. Reklam bütçenizi işletmenizin hedeflerine göre birlikte belirleriz. Genellikle aylık 5.000-15.000 TL arası reklam bütçesi öneriyoruz.',
    },
    {
      question: 'Sözleşme süresi ne kadar?',
      answer:
        'İlk kurulum ve tasarım hizmetleri tek seferlik ücretlendirilir. Aylık hizmetler (sosyal medya, reklam yönetimi, SEO) için minimum 6 aylık sözleşme yapılır. Sözleşme sonunda dilediğiniz zaman iptal edebilir veya yenileyebilirsiniz.',
    },
    {
      question: 'Hangi paketi seçmeliyim?',
      answer:
        'Yeni başlıyorsanız ve dijital varlık oluşturmak istiyorsanız Dijital Varlık Paketi, aktif olarak müşteri kazanmak istiyorsanız Satış Odaklı Paket, bölgenizde lider olmak istiyorsanız Bölge Liderliği Paketi sizin için uygundur. Ücretsiz danışmanlıkta size en uygun paketi önerebiliriz.',
    },
    {
      question: 'Destek hizmeti var mı?',
      answer:
        'Evet, tüm paketlerde öncelikli müşteri desteği sunuyoruz. WhatsApp, telefon ve e-posta ile 7/24 ulaşabilirsiniz. Ayrıca her pakette düzenli performans raporları ve strateji toplantıları yapılır.',
    },
  ];

  return (
    <section ref={ref} className="py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="lg:sticky lg:top-32"
          >
            <h2 className="font-poppins font-bold text-3xl lg:text-4xl text-gray-900 mb-4">
              Sıkça Sorulan Sorular
            </h2>
            <p className="font-poppins text-base text-gray-600 mb-8">
              Paketler hakkında merak ettiklerinizi burada bulabilirsiniz
            </p>

            <div className="bg-gradient-to-br from-[#007dff]/5 to-[#007dff]/10 rounded-2xl p-6 border border-[#007dff]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#007dff] rounded-xl flex-shrink-0">
                  <i className="ri-question-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-poppins font-bold text-base text-gray-900 mb-2">
                    Sorunuz mu var?
                  </h3>
                  <p className="font-poppins text-sm text-gray-600 mb-4">
                    Aklınıza takılan başka sorular için bizimle iletişime geçin
                  </p>
                  <button
                    onClick={() => window.REACT_APP_NAVIGATE('/iletisim')}
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#007dff] text-white rounded-lg font-poppins text-sm font-semibold hover:bg-[#0066dd] transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-message-3-line"></i>
                    İletişime Geç
                  </button>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Side - FAQ List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-4"
          >
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-[#007dff] transition-all duration-300"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-4 flex items-center justify-between gap-4 text-left cursor-pointer"
                >
                  <span className="font-poppins font-semibold text-sm text-gray-900">
                    {faq.question}
                  </span>
                  <div
                    className={`w-8 h-8 flex items-center justify-center bg-[#007dff]/10 rounded-lg flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-[#007dff] text-lg"></i>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-4 pt-0">
                    <p className="font-poppins text-sm text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PackageFAQ;
